import { render, staticRenderFns } from "./AccordionContent.vue?vue&type=template&id=fbeef8b4&scoped=true"
import script from "./AccordionContent.vue?vue&type=script&lang=js"
export * from "./AccordionContent.vue?vue&type=script&lang=js"
import style0 from "./AccordionContent.vue?vue&type=style&index=0&id=fbeef8b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbeef8b4",
  null
  
)

export default component.exports